import { render, staticRenderFns } from "./delivery-method.vue?vue&type=template&id=2841bad4&"
import script from "./delivery-method.vue?vue&type=script&lang=js&"
export * from "./delivery-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports